module.exports = __webpack_public_path__ + "static/media/best.8fce10af.jpg";